import Vue from 'vue';
import Curriculum from 'client/js/models/curriculum.js'
import moment from 'moment';
import { sleep } from 'common/helpers/async-tools'

const state = {
      courseUpdates: {},
      updating: false
   }

const getters = {
   // are any courses currently being updated
   isUpdatingCourses: state => state.updating,

   // is updating for a specific course code
   isCourseUpdating: state => code => {
      return state.courseUpdates.hasOwnProperty(code)
   }
}

const mutations = {
   // Set course updating using code as key and timestamp as value
   setCourseUpdating(state, { code, timestamp }) {
      Vue.set(state.courseUpdates, code, timestamp)
      state.updating = true
   },

   clearCourseUpdating(state, code) {
      Vue.delete(state.courseUpdates, code)
      state.updating = Object.keys(state.courseUpdates).length > 0
   }
}

const actions = {
   // Trigger an update of the cached course data
   async refreshCourse({ commit, state }, {courseId, version}) {
      console.log('Starting course cache refresh:', courseId, version)
      const courseStatus = await Curriculum.refreshCourseCache(courseId, version)
      commit('setCourseUpdating', {code: courseStatus.code, timestamp: courseStatus.cacheTimestamp})
      while (Curriculum.getCourseCacheRefreshStatus(courseId, version) === true) {
         // Wait for the course to finish updating
         await sleep(1000)
      }
      console.log('Course cache refresh complete:', courseId)
      commit('clearCourseUpdating', courseId)
   },

   async checkCourseRefresh({ commit, state }, courseId) {
      const lastTimestamp = state.courseUpdates[courseId]
console.log('Checking course refresh:', courseId)
      const loadedCourse = await Curriculum.getCourseCacheStatus(courseId)
      if (!loadedCourse.code)
         throw new Error("Course Not Found")

      if (lastTimestamp != loadedCourse.cacheTimestamp) {
         commit('clearCourseUpdating', courseId)
      }
   }
}

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
}
